"use client";

import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import LiveBlink from "@/components/ui/LiveBlink";
import { isLiveBlogValue } from "@/lib/liveBlog";
import { useRouter } from "next/navigation";
import { FaRegBookmark, FaRegCommentDots } from "react-icons/fa";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getSectionUrl, getFocusPointStyle, toFieldString, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';

type FieldConfig = {
  hidden?: boolean;
  value?: string | boolean;
  customClass?: string;
};

type Props = {
  category?: FieldConfig;
  sectionUrl?: string;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  priority?: boolean;
  imageMetadata?: ImageMetadata;
  templatetype?: FieldConfig;
  isliveblog?: FieldConfig;
};

export default function VerticalBigImagecategoryNews({
  category = { hidden: false, value: "TAMIL NADU", customClass: "" },
  sectionUrl,
  title = { hidden: false, value: "ஹனி ட்ராப்பிங்: நவி மும்பையில் இருந்து 7 பேர் கொண்ட கும்பலை கோவை சைபர் கிரைம் போலீசார் கைது செய்தனர்", customClass: "" },
  excerpt = { hidden: false, value: "அவர்கள் அப்சல் ரசூல்மானால் பணியமர்த்தப்பட்டனர் மற்றும் நவி மும்பையில் உள்ள உல்வே, செக்டர் 19 இல் உள்ள ஒரு அடுக்குமாடி குடியிருப்பில் இயங்கி வந்தனர்.", customClass: "" },
  timeAgo = { hidden: false, value: "15 min ago", customClass: "" },
  imageSrc = { hidden: false, value: FALLBACK_IMAGE, customClass: "" },
  slug,
  priority = false,
  imageMetadata,
  templatetype = { hidden: false, value: "", customClass: "" },
  isliveblog = { hidden: false, value: "", customClass: "" },
}: Props) {
  const router = useRouter();
  const categoryValue = toFieldString(category?.value);
  const titleValue = toFieldString(title?.value);
  const excerptValue = toFieldString(excerpt?.value);
  const timeAgoValue = getTimeAgo(toFieldString(timeAgo?.value));
  const imageSrcValue = getImageUrl(toFieldString(imageSrc?.value)) || FALLBACK_IMAGE;
  const isLiveBlog = isLiveBlogValue(templatetype?.value) || isLiveBlogValue(isliveblog?.value);
  const sectionUrlValue = getSectionUrl(sectionUrl);
  console.log("isliveblog prop=", isliveblog, "| templatetype=", isliveblog?.value);
  const content = (
    <article className="flex flex-col overflow-hidden p-4 gap-4">
      {/* IMAGE */}
      {!imageSrc?.hidden && (
        <div className="">
          <div className="relative w-full aspect-[16/9] overflow-hidden">
            <Image
              src={imageSrcValue}
              alt={titleValue}
              fill
              className={`object-cover w-full h-full ${imageSrc?.customClass || ""}`}
              style={getFocusPointStyle(imageMetadata)}
              loading={priority ? "eager" : "lazy"}
              fetchPriority={priority ? "high" : "auto"}
              priority={priority}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 400px"
              placeholder="blur"
              blurDataURL={BLUR_PLACEHOLDER}
            />
          </div>
        </div>
      )}

      {/* CONTENT */}
      <div className="flex flex-col gap-2">
        {/* Category */}
        {!category?.hidden && (
          sectionUrlValue ? (
            <span
              className={`text-14-tamil-600 text-012061 tracking-wide uppercase hover:underline cursor-pointer ${category?.customClass || ""}`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                router.push(sectionUrlValue);
              }}
            >
              {categoryValue}
            </span>
          ) : (
            <div className={`text-14-tamil-600 text-012061 tracking-wide uppercase ${category?.customClass || ""}`}>
              {categoryValue}
            </div>
          )
        )}

        {/* Title */}
        {!title?.hidden && (
 <h3 className={`text-012061 text-24-tamil-700 md:text-16-tamil-700 leading-[1.4] ${title?.customClass || ""}`}>
            {isLiveBlog && (
              <LiveBlink />
            )}
            {titleValue}
          </h3>
        )}

        {/* Excerpt */}
        {!excerpt?.hidden && (
          <p className={`text-14-tamil-400 sm:text-16-tamil-400 text-222222 leading-[1.6] line-clamp-2 ${excerpt?.customClass || ""}`}>
            {excerptValue}
          </p>
        )}

        <div className="flex items-center justify-between gap-2">
          {!timeAgo?.hidden && (
            <span className={`text-12-tamil-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>
          )}

          <div className="flex items-center gap-4">
            <MessageIcon
              id="message-icon-1"
              slug={slug}
              category={BOOKMARK_CATEGORIES.NEWS}
              title={titleValue}
              thumbnailUrl={imageSrcValue}
              description={excerptValue}
              articleUrl={slug ? `/${slug}` : undefined}
            />
          </div>
        </div>
      </div>
    </article>
  );

  if (slug) {
    return (
      <Link href={`/${slug}`} className="block  transition-colors cursor-pointer">
        {content}
      </Link>
    );
  }

  return content;
}
